import { create } from "zustand";

interface QuickStartStore {
  /** Set true by create-concept mutation onSuccess; read by the tour orchestrator. */
  conceptJustCreated: boolean;
  /** Called by create-concept mutation onSuccess. */
  setConceptJustCreated: (value: boolean) => void;
  /** Called by orchestrator the moment the new-user variant fires (renders step 1). */
  consumeJustCreated: () => void;

  /** Set by guided setup Start (facets 1b): fires the short "setup-complete" tour on Curate. */
  setupJustCompleted: boolean;
  setSetupJustCompleted: (value: boolean) => void;
  consumeSetupCompleted: () => void;

  /** Bumped by replay(); orchestrator effect depends on it to re-fire. */
  replayRequestedAt: number | null;
  /** True after replay() until tour ends; orchestrator bypasses the localStorage seen check while this is true. */
  replaySessionOverride: boolean;
  /** Called by replay link in GuidesCatalogDrawer. */
  replay: () => void;
  /** Called by orchestrator on tour complete/skip/unmount. */
  clearReplayOverride: () => void;
}

// Tour-active mutex was previously surfaced here as `isActive`/`setIsActive`.
// Retired 2026-05-21 — useOnboardingStore now owns activeSurface; consumers
// derive tour-vs-other mutex from `canShow.announcement` or `activeSurface`.

export const useQuickStartStore = create<QuickStartStore>((set) => ({
  conceptJustCreated: false,
  setConceptJustCreated: (value) => set({ conceptJustCreated: value }),
  consumeJustCreated: () => set({ conceptJustCreated: false }),

  setupJustCompleted: false,
  setSetupJustCompleted: (value) => set({ setupJustCompleted: value }),
  consumeSetupCompleted: () => set({ setupJustCompleted: false }),

  replayRequestedAt: null,
  replaySessionOverride: false,
  replay: () => set({ replayRequestedAt: Date.now(), replaySessionOverride: true }),
  clearReplayOverride: () => set({ replaySessionOverride: false }),
}));
